import { render, staticRenderFns } from "./FormularioPrecoDialogo.vue?vue&type=template&id=634ffcd8&"
import script from "./FormularioPrecoDialogo.vue?vue&type=script&lang=js&"
export * from "./FormularioPrecoDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports